module.exports = __webpack_public_path__ + "images/report_edit.png";